import { useEffect, useRef, useState } from "react";
import { Avatar, Dropdown, message, Button } from "antd";
import { useNavigate, useLocation, Link } from "react-router-dom";
import type { SelectProps } from "antd/es/select";
import Parser from "html-react-parser";
import { cloneDeep, delay } from "lodash-es";
import { useSelector, useDispatch } from "react-redux";
import dataJson from "@/../public/data.json";
import api from "@/api";
import { publicPath, isLogoTargetPortalHome, fullScreenScrolling } from "@/utils/base";
import { enableScroll, goLogin } from "@/utils";

import "./index.less";
import { getAuthTokenValue, removeAuthToken } from "@kaihong/utils/lib/khAuthToken";
const tvHeaderPrefix = "tv-header";

const Header = () => {
  const { header, login, avatar_icon, req_err } = dataJson;
  const [authorization, setAuthorization] = useState<string | null>("");
  const [hiddenHeader, setHiddenHeader] = useState<boolean>(false);
  const [headerOpaque, setHeaderOpaque] = useState<boolean>(false); // 头部不透明
  const [options, setOptions] = useState<SelectProps<object>["options"]>([]);
  const [inputWidth, setInputWidth] = useState<number>(250);
  const [open, setOpen] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const AutoCompleteRef = useRef<any>();
  const [dropdownItems, setDropdownItems] = useState<any[]>(header.avatar_dropdown);
  const navigate = useNavigate();
  const location = useLocation();
  const pathArr = location?.pathname?.split("/");
  const currentName = pathArr[pathArr?.length - 1];
  const [current, setCurrent] = useState(currentName);
  const [isHover, setIsHover] = useState(null);
  const [someDomeEnter, setSomeDomeEnter] = useState<boolean>(false);

  const dispatch = useDispatch();
  const scrollHeight = useSelector((state: any) => state.scrollHeight);
  const scrollDirection = useSelector((state: any) => state.scrollDirection);
  const scrollDistance = useSelector((state: any) => state.scrollDistance);
  const isClickCauseScroll = useSelector((state: any) => state.isClickCauseScroll);
  const userDataChange = useSelector((state: any) => state.userDataChange);
  const userData = useSelector((state: any) => state.userData);
  const portalAuthorization = useSelector(
    (state: any) => state.portalAuthorization || getAuthTokenValue("Authorization")
  );

  const setDropdown = (userDetail: any) => {
    const dropdownCopy = cloneDeep(header.avatar_dropdown);
    const dropdownItemCopy = dropdownCopy.map((item: any, index: number) => {
      if (!item.key) {
        if (index === 0) {
          return {
            label: (
              <div className="one-line-ellipsis" title={userDetail.userName}>
                {userDetail.userName}
              </div>
            ),
          };
        } else {
          return item;
        }
      } else {
        return {
          key: item.key,
          label: (
            <div onClick={() => dropdownClick(item)} className={`${tvHeaderPrefix}-dropdown-label`}>
              {item.label}
            </div>
          ),
        };
      }
    });
    setDropdownItems(dropdownItemCopy);
  };
  const dropdownClick = async (dropdownItem: any) => {
    if (dropdownItem.url) {
      navigate(publicPath + dropdownItem.url);
    } else if (dropdownItem.key === "3") {
      const res: any = await api.systemLogout();
      if (res.code === 200) {
        removeAuthToken("Authorization");
        removeAuthToken("X-Access-Token");
        dispatch({
          type: "setPortalAuthorization",
          payload: "",
        });
        goLogin();
      } else {
        message.error(res.msg || req_err);
      }
    }
  };

  const searchResult: (any: string) => void = (query: string) => {
    api
      .documentQuery({ keyword: query })
      .then((res: any) => {
        const resData = res.data;
        const resList = resData.datas.map((item: any) => {
          return {
            value: item.url,
            label: (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <span
                  style={{ width: "30%", marginRight: 50 }}
                  className="one-line-ellipsis"
                  title={item.navigationBar.replace(/<[^>]+>/g, "")}
                >
                  {item.navigationBar}
                </span>
                <span
                  style={{ width: "60%" }}
                  className="one-line-ellipsis"
                  title={item.highlightContent.replace(/<[^>]+>/g, "")}
                >
                  {Parser(item.highlightContent)}
                </span>
              </div>
            ),
          };
        });
        setOptions(resList);
        setOpen(true);
      })
      .catch(() => {
        setOptions([]);
      });
  };
  const toLink = (e: any) => {
    navigate(`${publicPath}${e.url}`);
    setCurrent(e.url);
  };

  const handleMouseEnter = (item: any) => {
    setIsHover(item.url);
    delay(() => {
      const menuItems: any = document.getElementsByClassName(`${tvHeaderPrefix}-menu-item`);
      for (let i = 0; i < menuItems.length; i++) {
        //遍历输出
        if (menuItems[i].className.indexOf("itemEnter") > -1) {
          setSomeDomeEnter(true);
          return;
        } else {
          setSomeDomeEnter(false);
        }
      }
    }, 0);
  };

  const handleSearch = (e: any) => {
    e ? searchResult(e) : setOptions([]);
  };

  const onSelect = (value: string) => {
    window.open(value, "_blank");
    setSearchValue("");
  };

  const inputFocus = () => {
    setInputWidth(650);
    delay(() => {
      setOpen(true);
    }, 500);
  };

  const inputBlur = () => {
    setInputWidth(250);
    setOpen(false);
  };

  const toUrl = (item: any) => {
    window.open(`${publicPath}${item.url}`, "_self");
  };

  // const handleClickOutside = (event: any) => {
  //   const isIpt = AutoCompleteRef.current.contains(event.target);

  //   if (!isIpt) {
  //     setInputWidth(250);
  //     setOpen(false);
  //   }
  // };

  const clickLogo = () => {
    setCurrent("");
    const atHome = isLogoTargetPortalHome(location.pathname);
    navigate(atHome ? `${publicPath || "/"}` : `${publicPath}/staging`);
  };

  useEffect(() => {
    setDropdown(userData);
  }, [userData]);

  useEffect(() => {
    if (header.fix_top_router.includes(currentName)) {
      if (isClickCauseScroll) {
        setHiddenHeader(true);
      } else {
        // 小于400展示头部
        if (scrollHeight < 400) {
          setHiddenHeader(false);
          setHeaderOpaque(false);
        } else {
          setHeaderOpaque(true);
          //大于400分情况判断
          // 向下滚动隐藏头部
          if (scrollDirection == "down") {
            setHiddenHeader(true);
          } else {
            // 向上滚动且是快速滚动才展示头部
            if (scrollDistance > 30) {
              setHiddenHeader(false);
            }
          }
        }
      }
    }
  }, [scrollHeight, currentName]);

  useEffect(() => {
    setCurrent(currentName);
    setHiddenHeader(false);
    setHeaderOpaque(false);
    const portalDom: any = document.getElementById("portal");
    portalDom.scrollTo(0, 0);
    const fullScreenPath = fullScreenScrolling.includes(location.pathname);
    !fullScreenPath && enableScroll("portal");
  }, [location]);

  useEffect(() => {
    const storageAuthorization = getAuthTokenValue("Authorization") || "";
    setAuthorization(storageAuthorization);
    // document.addEventListener("click", handleClickOutside);
    storageAuthorization &&
      dispatch({
        type: "setUserDataChange",
        payload: userDataChange + 1,
      });
    // return () => {
    //   document.removeEventListener("click", handleClickOutside);
    // };
  }, []);

  return (
    <div className={`${tvHeaderPrefix} ${hiddenHeader ? "displayNone" : ""} ${headerOpaque ? "headerOpaque" : ""}`}>
      <div className={`${tvHeaderPrefix}-left`}>
        <img src={header.logo} alt="" className={`${tvHeaderPrefix}-logo`} onClick={clickLogo} />
        <div className={`${tvHeaderPrefix}-menu`}>
          {header.header_arr.map((item: any, i: number) => {
            if (i !== 0) {
              return;
            }
            return (
              <div
                key={item.key}
                className={`${tvHeaderPrefix}-menu-item ${item.url == current ? "on" : ""} ${
                  item.url == isHover ? (item.url == current ? "" : "itemEnter") : "itemLeave"
                } ${someDomeEnter ? "dom-enter" : ""}`}
                onClick={() => toLink(item)}
                onMouseEnter={() => handleMouseEnter(item)}
                onMouseLeave={() => {
                  setIsHover(null);
                  setSomeDomeEnter(false);
                }}
              >
                {item.label}
                {item?.menuList?.length ? (
                  <div className={`${tvHeaderPrefix}-more`} style={{ height: item.url == isHover ? item.height : 0 }}>
                    <div className={`${tvHeaderPrefix}-more-left`}>
                      <span>{item.label}</span>
                    </div>
                    <div className={`${tvHeaderPrefix}-more-right`}>
                      {item.menuList.map((ele: any) => {
                        return (
                          <div key={ele.key} className={`${tvHeaderPrefix}-more-links`}>
                            <span
                              className={`${tvHeaderPrefix}-links-title ${ele.url ? "isLink" : ""}`}
                              onClick={() => toUrl(ele)}
                            >
                              {ele.title}
                            </span>
                            {ele.list.map((e: any) => {
                              return (
                                <span key={e.key} className={`${tvHeaderPrefix}-more-link`} onClick={() => toUrl(e)}>
                                  {e.label}
                                </span>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
      <div className={`${tvHeaderPrefix}-right`}>
        {/* <div ref={AutoCompleteRef} className={`${tvHeaderPrefix}-autoComplete`}>
          <AutoComplete
            style={{ width: inputWidth, transition: "all 0.5s" }}
            options={options}
            onSelect={onSelect}
            value={searchValue}
            onSearch={debounce(handleSearch, 300)}
            open={open}
            maxLength={100}
            popupClassName={`${tvHeaderPrefix}-popupClass`}
            onBlur={inputBlur}
            onChange={(e: any) => {
              setSearchValue(e);
            }}
            onFocus={inputFocus}
          >
            <Input
              size="large"
              allowClear
              placeholder="请输入关键词"
              prefix={<img src={header.search} alt="" width={16} />}
              className={`${tvHeaderPrefix}-input`}
            />
          </AutoComplete>
        </div> */}
        <Link to={`${publicPath}/staging`} className={`${tvHeaderPrefix}-staging`}>
          {header.staging}
        </Link>
        {portalAuthorization && authorization ? (
          <Dropdown
            menu={{ items: dropdownItems }}
            placement="bottomRight"
            overlayClassName={`${tvHeaderPrefix}-dropdown`}
          >
            <Avatar
              icon={<img src={userData.avatar || avatar_icon} className={`${tvHeaderPrefix}-avatar-icon`} />}
              className={`${tvHeaderPrefix}-avatar`}
            />
          </Dropdown>
        ) : (
          <Button
            type="link"
            className={`${tvHeaderPrefix}-toLogin`}
            onClick={() => {
              goLogin();
            }}
          >
            {login.login_text}
          </Button>
        )}
      </div>
    </div>
  );
};
export default Header;
